import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openCartModal} from '../modules/active_modal';
import { navigate } from '../modules/high_level_actions';

import CommerceBarItem from './CommerceBarItem.jsx';
import HeroesCommerceBar from './HeroesCommerceBar.jsx';
import NegLiteCommerceBar from './NegLiteCommerceBar.jsx';
import NegativeOptionCommerceBar from './NegativeOptionCommerceBar.jsx';

class MemberCommerceBar extends Component {

  constructor(props) {
    super(props);
  }

  featuredSelectionMobile(evt){
    this.props.dispatch(navigate(evt))
    // evt.preventDefault();
  }

  render() {
    let {dispatch, storeType, store_bundle_pricing, computedCart, path, second_book, third_book, preorder_price, customer, isLoggedIn, tla} = this.props,
      oCommerceBar = '';
    // Define CommerceBarItems and button text. Begin by assuming user is not logged in.
    const itemSharedProps = { status: customer.status };
    // Set FS item flag for enroll vs member
    let tempPrice1 = '1 Credit';
    // Remove FS item flag if no creadits are available
    if (isLoggedIn && customer.credit_total <= 0){
      tempPrice1 = '';
    }

    let nBoxItems   = [];
    computedCart.items.forEach( i => {
      if( i && i.quantity && i.quantity > 1 ) new Array(i.quantity - 1).fill().map( x => nBoxItems.push(i) );
      nBoxItems.push( i );
    });

    let oItemOne   = <CommerceBarItem {...itemSharedProps} product={nBoxItems[0]} i={0} tempPrice = {tempPrice1} />;
    let oItemTwo   = <CommerceBarItem {...itemSharedProps} product={nBoxItems[1]} i={1} tempPrice = {'$' + second_book } />;
    let oItemThree = <CommerceBarItem {...itemSharedProps} product={nBoxItems[2]} i={2} tempPrice = {'$' + third_book } />;
    let oItemFour  = <CommerceBarItem {...itemSharedProps} product={nBoxItems[3]} i={3} tempPrice = {'$' + preorder_price } />

    // Determine whether to disable button; start by assuming it's not disabled
    let bButtonDisabled = false;

    if (!computedCart.items[0] && computedCart.items.length < 2) {
      bButtonDisabled = true;
    }

    if(storeType === "Neglite") oCommerceBar = <NegLiteCommerceBar {...this.props} />;
    else oCommerceBar = <NegativeOptionCommerceBar {...this.props} />;


    // Set conditional CSS classNames and display text
    //@TODO condense all the checks for which section is active!!!
    let Featured           = tla === "DVD" ? "Director's": "Featured";
    let sFeaturedHeaderTxt = (path === '/' ? Featured + ' Selections' : 'View The ' + Featured + ' Selections');
    let sFeaturedActive    = (path === '/' ? 'active' : '');
    let nCartSubTotal      = computedCart.subtotal;
    let hasBundlePricing   = store_bundle_pricing ? 'has-bundle': 'non-bundle';
    let sButtonText        = 'Checkout';

    // FINALLY we can return elements
    return (
      <div className="commerce-bar member-commerce">
          {/* Tabs for mobile only */}
          <a
            className={"mobile-tab left header-link " + (path === '/catalog' ? '' : 'active')}
            href="/"
            onClick={(evt) => dispatch(navigate(evt, false))}
          >
            {Featured} Selections
          </a>
          <a
            className={"mobile-tab left header-link " + (path === '/catalog' ? 'active' : '')}
            href="/catalog"
            onClick={(evt) => dispatch(navigate(evt))}
          >
            The Catalog
          </a>

            {oCommerceBar}
            <HeroesCommerceBar activeHero="1" path={path}/>

            <div className={ "commerce-bar-mobile " + hasBundlePricing} >
              <div className="fs-item-wrapper-mobile">
                {oItemOne}
              </div>
              <div className="cart-items-wrapper-mobile">
                {oItemTwo}
                {oItemThree}
                {oItemFour}
              </div>
              <button
                  className = "btn-primary checkout"
                  onClick   = {() => dispatch( openCartModal() )}
                  disabled  = {bButtonDisabled}
                >
                  {sButtonText}
                  <br />
                  ${nCartSubTotal.toFixed(2)}
                </button>
            </div>
      </div>
    );
  }
};

MemberCommerceBar.defaultProps = {
  path: '/',
  featured: [],
  customer: {}
};

function mapStateToProps(state){
    return {
      'path': state.path,
      'customer': state.customer,
      'preorder_price': state.store.preorder_price,
      'second_book': state.store.second_book,
      'third_book': state.store.third_book,
      'isLoggedIn': state.isLoggedIn,
      'computedCart': state.computedCart,
      'storeType': state.store.type,
      'tla': state.store.tla,
      'store_bundle_pricing': state.store.bundle_pricing
    };
}

export default connect(mapStateToProps)(MemberCommerceBar);


// WEBPACK FOOTER //
// ./src/components/MemberCommerceBar.jsx